import axios from "../helpers/axioxInstance";
import URLS from "../constData/urls";

export const fetchInactiveCeaDetails = async ({
  pageNum = 1,
  pageSize = 30,
  requestBody,
  controller,
}) => {
  const config = controller ? { signal: controller.signal } : {};

  const response = await axios.post(
    `${URLS.DRM_INACTIVE_CEA_DETAILS}?pageNum=${pageNum}&pageSize=${pageSize}`,
    requestBody,
    config
  );

  if (response.status >= 400) {
    throw new Error(response.statusText || "Failed to fetch inactive CEA details");
  }

  return response.data;
};
